// extracted by mini-css-extract-plugin
export var overlay = "BackgroundStaticVideo-module--overlay--832b1";
export var video = "BackgroundStaticVideo-module--video--3ca47";
export var wrapper = "BackgroundStaticVideo-module--wrapper--08484";